module.exports = __webpack_public_path__ + "img/VN.faa818be.svg";